// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/whyagcx_herobg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/whyagcx_herobg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/whyuserbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/whyagcx_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../public/images/whyagcx_bg_light.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wagce-page {
  background: #171A20;
  color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 80px;
}


body.light_theme .wagce-page {
  background: #fff;
  color: #161616;
}

.wagce-hero {
  padding: 84px 0 48px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 900px;
  display: flex;
  align-items: center;
}


body.light_theme .wagce-hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.wagce-hero__inner {
  max-width: 740px;
}

.whyagcx_hero_vector {
  width: 670px;
  max-width: 100%;
  opacity: 0.80;
}

.wagce-hero__layout {
  display: flex;
  gap: 32px;
  align-items: center;
}

.wagce-hero span.wagce-eyebrow {
  font-size: 14px;
  text-transform: uppercase;
  border: 1px solid rgb(209 170 103 / 30%);
  color: #D1AA67;
  border-radius: 50px;
  padding: 8px 15px;
  font-weight: 500;
  margin-bottom: 32px;
  display: inline-block;
  letter-spacing: 0.70px;
}

.wagce-stats-box {
  background: linear-gradient(#1a1d24, #1a1d24) padding-box, linear-gradient(179deg, rgba(209, 170, 103, 0.65) 0%, rgb(209 170 103 / 3%) 50%, rgb(255 255 255 / 0%) 100%) border-box;
  border: 1px solid transparent;
  border-radius: 24px;
  padding: 44px 48px;
  display: flex;
  flex-direction: column;
  gap: 36px;
  margin-top: 0px;
  margin-bottom: 24px;
}

body.light_theme .wagce-stats-box {
  background: #e3e2e2;
  margin-top: 60px;
  border: 1px solid transparent;
}

.wagce-stats-row {
  display: flex;
  align-items: center;
}

.wagce-stats-row--top {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.wagce-stats-row--bottom {
  display: flex;
  justify-content: center;
  gap: 64px;
}

.wagce-stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
}

.wagce-stat-card__icon {
  width: 68px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wagce-stat-card__icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.wagce-stat-card__content {
  display: flex;
  flex-direction: column;
}

.wagce-stat-card__content strong {
  display: block;
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
  margin-bottom: 4px;
}

body.light_theme .wagce-stat-card__content strong {
  color: #161616;
}

body.light_theme .wagce-stat-card__content span {
  color: #535353;
}

.wagce-stat-card__content span {
  color: #9CA3AF;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.35;
  max-width: 260px;
}

/* body.light_theme .wagce-stat-card__content span {
  color: rgba(22, 22, 22, 0.72);
} */

/* .wagce-eyebrow {
  display: inline-block;
  margin-bottom: 32px;
  padding: 7px 16px;
  border: 1px solid rgb(209 170 103 / 20%);
  border-radius: 999px;
  background: none;
  color: #D1AA67;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.70px;
  text-transform: uppercase;
} */

.wagce-hero h1,
.wagce-section h2,
.wagce-card h3,
.wagce-cta h2 {
  color: inherit;
}

.wagce-hero h1 {
  font-size: 72px;
  line-height: 1.14;
  margin-bottom: 18px;
  letter-spacing: -1.70px;
  font-weight: 700;
}

.wagce-hero h1 span {
  color: #D1AA67;
}

.wagce-hero p,
.wagce-section__head p,
.wagce-card p,
.wagce-cta p {
  color: #9CA3AF;
}

body.light_theme .wagce-hero p,
body.light_theme .wagce-section__head p,
body.light_theme .wagce-card p,
body.light_theme .wagce-cta p {
  color: #454545;
}

.wagce-hero p {
  width: 86%;
  font-weight: 300;
  font-size: 20px;
  line-height: 170%;
}

.wagce-section.whyagcx_userstay h2 {
  font-weight: 600;
  background: linear-gradient(270deg, #D1AA67, #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

body.light_theme .wagce-section.whyagcx_userstay h2 {
  background: linear-gradient(270deg, #df872c, #373636);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

/* body.light_theme .wagce-hero p,
body.light_theme .wagce-section__head p,
body.light_theme .wagce-card p,
body.light_theme .wagce-cta p {
  color: rgba(22, 22, 22, 0.72);
} */

.wagce-actions,
.wagce-cta__actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 32px;
}

.wagce-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(255 255 255 / 12%);
  min-width: 198px;
  background: rgb(54 53 53 / 85%);
  padding: 15px 24px;
  color: #E5E7EB;
  align-items: center;
  gap: 7px;
  font-size: 18px;
  border-radius: 999px;
  font-weight: 500;
  text-decoration: none;
  transition: transform 0.2s ease, opacity 0.2s ease, background 0.2s ease;
}

.wagce-btn:hover {
  transform: translateY(-1px);
  opacity: 0.96;
  color: #fff;
}

.wagce-btn--primary {
  background: #D1AA67;
  color: #fff;
  border-color: #D1AA67;
}

/* 
.wagce-btn--secondary {
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
  background: transparent;
} */

/* .wagce-btn--ghost {
  border: 1px solid rgba(209, 170, 103, 0.32);
  color: #d1aa67;
  background: rgba(209, 170, 103, 0.08);
} */
/* 
  body.light_theme .wagce-btn--secondary {
    border-color: rgba(17, 17, 17, 0.14);
    color: #161616;
  }

  body.light_theme .wagce-btn--ghost {
    border-color: rgba(209, 170, 103, 0.28);
    color: #9d793d;
    background: rgba(209, 170, 103, 0.12);
  } */

.wagce-section.whyagcx_userstay {
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 2500px;
  position: relative;
}

body.light_theme .wagce-section.whyagcx_userstay {
  background-color: #fff;
  background-image: none;
}

.whyagcx_userstay_wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.wagce-section.whyagcx_userstay.state-pinned .whyagcx_userstay_wrapper {
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 99;
}

.wagce-section.whyagcx_userstay.state-after .whyagcx_userstay_wrapper {
  position: absolute;
  top: auto;
  bottom: 0;
}

section.wagce-section.wagce-section--soft {
  padding: 100px 0 90px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

body.light_theme section.wagce-section.wagce-section--soft {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

span.wagce-eyebrow {
  font-size: 20px;
  color: #D1AA67;
  font-weight: 500;
  letter-spacing: 1.9px;
}

.agcx_why_services {
  width: 100%;
  display: flex;
  gap: 72px;
  align-items: center;
}

.agcx_why_services .wagce-section__head.wagce-section__head--left {
  max-width: 580px;
}

.wagce-section.wagce-section--soft h2 span {
  color: #D1AA67;
}

.wagce-section.wagce-section--soft .agcx_why_services h2 {
  margin: 24px 0px;
}

.agcx_why_services .wagce-section h2 {
  max-width: 90%;
  margin: 18px 0px;
  font-weight: 500;
}

.agcx_why_services .wagce-section__head p {
  font-size: 24px;
  font-weight: 300;
  line-height: 160%;
}

section.wagce-section.the_experience_section {
  padding: 120px 0px;
}

.the_experience_section .wagce-eyebrow {
  letter-spacing: 3px;
  font-size: 13px;
  padding-bottom: 13px;
  display: block;
}

.wagce-section.the_experience_section h2 span {
  color: #D1AA67;
}

.wagce-section.the_experience_section p.subtext {
  padding-top: 8px;
  font-size: 16px;
}

img.roatateright {
  transform: rotate(180deg);
}

.the_experience_section .wagce-section__head {
  max-width: 840px;
  margin: 0 auto 36px;
}

.feature_cta.d-flex {
  width: 100%;
  background: rgb(255 255 255 / 5%);
  border: 1px solid rgb(209 170 103 / 25%);
  border-radius: 22px;
  position: relative;
  gap: 24px;
  padding: 36px;
  margin-top: 32px;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

body.light_theme .feature_cta.d-flex {
  background: rgb(255 255 255 / 30%);
}

.feature_cta.d-flex h4 {
  font-weight: 700;
  font-size: 24px;
  color: #D1AA67;
}

.feature_cta.d-flex::before {
  width: 120px;
  height: 120px;
  background: rgb(209 170 103 / 30%);
  content: "";
  position: absolute;
  left: 0px;
  top: 0px;
  filter: blur(30px);
}

.agcx_why_services .wagce-section__head .feature_cta p {
  font-size: 19px;
  font-weight: 400;
}

.wagce-section__head {
  max-width: 100%;
  margin: 0 auto 28px;
  text-align: center;
}

.wagce-section__head--left {
  margin: 0;
  text-align: left;
}

.wagce-section h2 {
  font-size: 54px;
  margin-bottom: 14px;
  font-weight: 600;
}


.wagce-section p.sub {
  max-width: 754px;
  font-size: 22px;
  line-height: 140%;
  font-weight: 300;
  color: #9EA6B6;
  margin: 24px auto;
}

body.light_theme .wagce-section p.sub {
  color: #1e1e1e;
}


.agcxstay_card.cardtwoeffect {
  transform: rotate(-15deg);
}

.why_agcx_user {
  max-width: 400px;
  width: 100%;
  position: relative;
  margin: 112px auto 0;
  height: 400px;
}

.agcxstay_card {
  max-width: 396px;
  width: 100%;
  background-color: #202329;
  border: 1px solid rgb(255 255 255 / 8%);
  border-radius: 30px;
  padding: 24px;
  box-shadow: 0px 16px 36px rgba(0, 0, 0, 0.5);
  min-height: 354px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.15s ease-out, opacity 0.15s ease-out;
}

body.light_theme .agcxstay_card {
  background-color: rgb(223 223 223 / 60%);
  border: 1px solid rgb(255 255 255 / 8%);
  box-shadow: 0px 16px 36px rgb(0 0 0 / 20%);
}


.whyagcx_stay_vector {
  max-width: 60px;
}

.stay_effect {
  background: rgb(255 255 255 / 5%);
  font-size: 12px;
  padding: 10px 20px;
  display: inline-block;
  border-radius: 50px;
  box-shadow: inset 2px 4px 16px rgb(248 248 248 / 6%);
  position: absolute;
  top: 20px;
  right: 20px;
}

.agcxstay_card h3 {
  font-size: 24px;
}

.agcxstay_card p {
  font-size: 12px;
  color: #a7a7a7;
}

body.light_theme .agcxstay_card p {
  color: #272626;
}

/* .wagce-card,
.wagce-list-card,
.wagce-cta {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  border-radius: 24px;
} */

/* body.light_theme .wagce-card,
body.light_theme .wagce-list-card,
body.light_theme .wagce-cta {
  border-color: rgba(17, 17, 17, 0.08);
  background: #fff;
} */

.wagce-card {
  padding: 28px;
}

.wagce-card h3 {
  font-size: 1.2rem;
  margin-bottom: 12px;
  font-weight: 700;
}

/* .wagce-list-card {
  padding: 26px;
} */

/* .wagce-list-item {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 14px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

body.light_theme .wagce-list-item {
  border-bottom-color: rgba(17, 17, 17, 0.08);
}

.wagce-list-item:last-child {
  border-bottom: none;
} */

/* .wagce-list-item__icon {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(209, 170, 103, 0.15);
  color: #d1aa67;
  font-weight: 700;
} */

.wagce-cta {
  padding: 54px;
  min-height: 420px;
  border-radius: 24px;
  margin-top: 32px;
  overflow: hidden;
  display: flex;
  border: 1px solid rgb(255 255 255 / 10%);
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background: rgb(255 255 255 / 5%);
  box-shadow: inset 0 0px 15px rgba(0, 0, 0, 0.25);
  position: relative;
}

.wagce-cta::before {
  width: 350px;
  height: 100%;
  background: rgb(209 170 103 / 25%);
  content: "";
  position: absolute;
  right: 190px;
  top: 0px;
  filter: blur(100px);
}

.wagce-cta h2 {
  margin-bottom: 20px;
  font-weight: 600;
  line-height: 1.1;
  font-size: 48px;
  letter-spacing: -1.2px;
}

.wagce-cta .wagce-btn {
  min-width: 165px;
  padding: 11px 24px;
  font-size: 14px;
  font-weight: 600;
  margin-right: 15px;
  margin-top: 15px;
}

.wagce-cta .wagce-btn:hover {
  color: #fff;
}

.cta_cntlft {
  max-width: 725px;
}

.wagce-cta h2 span {
  color: #D1AA67;
}

.wagce-cta p {
  font-size: 14px;
  font-weight: 300;
}

.wagce-cta__actions {
  max-width: 550px;
  position: absolute;
  right: 0px;
  bottom: 0px;
}

.wagce-journey {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 42px;
  padding-top: 26px;
}

.wagce-journey-card {
  padding: 28px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.term_usages_card {
  width: 100%;
  position: relative;
  height: 100%;
}

.termcard_img {
  position: absolute;
}

body.light_theme .termcard_img {
  opacity: 0.3;
}

.cnttermswhy {
  padding: 42px 42px 0px;
  /* color: #fff; */
  position: relative;
  min-height: 270px;
}

.term_usages_card h3 {
  font-size: 40px;
  font-weight: 600;
}

.term_usages_card h3 span {
  color: #D1AA67;
  display: block;
}

.term_usages_card p {
  font-size: 18px;
  color: rgb(255 255 255 / 60%);
}

body.light_theme .term_usages_card p {
  color: rgba(0, 0, 0, 0.7);
}

.number_term {
  font-size: 52px;
  font-weight: 600;
  color: #D1AA67;
}

.term_usages_card.terms_onebl .number_term {
  position: absolute;
  bottom: -90px;
}


body.light_theme .wagce-journey-card {
  border-color: rgba(17, 17, 17, 0.08);
  background: #fff;
}

.wagce-journey-card__step {
  display: inline-flex;
  min-width: 48px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-radius: 999px;
  margin-bottom: 16px;
  background: rgba(209, 170, 103, 0.14);
  color: #d1aa67;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.wagce-journey-card h3 {
  margin-bottom: 12px;
  font-size: 1.2rem;
}

.wagce-journey-card p {
  margin: 0;
  color: rgba(255, 255, 255, 0.76);
}

body.light_theme .wagce-journey-card p {
  color: rgba(22, 22, 22, 0.72);
}

@media (max-width:1500px) {


  .term_usages_card h3 {
    font-size: 36px;
  }

  .term_usages_card p {
    font-size: 15px;
  }

  .cnttermswhy {
    padding: 32px 32px 0px;
    min-height: 230px;
  }

  .wagce-hero h1 {
    font-size: 60px;
  }

}


@media (max-width:1367px) {

  .cnttermswhy {
    min-height: 200px;
  }

  .wagce-hero h1 {
    font-size: 52px;
  }

  .wagce-section h2 {
    font-size: 48px;
  }

  .term_usages_card h3 {
    font-size: 32px;
  }

  .term_usages_card p {
    font-size: 14px;
  }

  .number_term {
    font-size: 40px;
  }



  .cta_cntlft {
    max-width: 50%;
  }

}


@media (max-width: 1200px) {


  .wagce-hero {
    padding: 84px 0 48px;
    min-height: 100%;
  }

  .wagce-page .container {
    max-width: 95%;
  }

  .wagce-hero p {
    width: 100%;
    font-size: 16px;
  }

  .wagce-stat-card__content strong {
    font-size: 20px;
  }

  .wagce-stat-card__content span {
    font-size: 14px;
  }

  .wagce-stats-box {
    padding: 36px;
  }

  .wagce-section h2 {
    font-size: 38px;
  }

  .wagce-section p.sub {
    max-width: 90% !important;
    font-size: 16px;
  }

  .agcx_why_services .wagce-section__head p {
    font-size: 16px;
  }

  span.wagce-eyebrow {
    font-size: 15px;
  }

  .feature_cta.d-flex {
    gap: 18px;
    padding: 24px;
  }

  .agcx_why_services .wagce-section__head .feature_cta p {
    font-size: 15px;
  }

  .feature_cta.d-flex h4 {
    font-size: 20px;
  }

  .term_usages_card h3 {
    font-size: 24px;
  }

  .number_term {
    font-size: 32px;
  }

  .wagce-hero h1 {
    font-size: 42px;
  }

  .wagce-btn {
    font-size: 13px;
    min-width: 150px;
    padding: 10px 22px;
  }

  .term_usages_card.terms_onebl .number_term {
    bottom: -40px;
  }

  .cnttermswhy {
    min-height: 190px;
    padding: 24px 24px 0px;
  }

  .wagce-journey {
    gap: 24px;
  }

  .wagce-cta__actions {
    max-width: 430px;
  }

}

@media (max-width: 991px) {


  .wagce-hero h1 {
    font-size: 32px;
  }

  .wagce-hero {
    padding: 48px 0 48px;
  }

  .wagce-page .container {
    max-width: 100%;
  }

  .wagce-hero p {
    margin-bottom: 0px;
    font-size: 15px;
  }

  .wagce-actions,
  .wagce-cta__actions {
    gap: 8px;
    margin-top: 22px;
  }

  .wagce-hero span.wagce-eyebrow {
    font-size: 12px;
    padding: 6px 12px;
    margin-bottom: 18px;
  }


  .wagce-stats-box {
    padding: 32px 24px;
    gap: 28px;
    margin-top: 0;
  }

  .wagce-stats-row--top,
  .wagce-stats-row--bottom {
    gap: 18px;
  }

  .wagce-stat-card__icon {
    width: 48px;
  }

  .wagce-stat-card__content strong {
    font-size: 18px;
  }

  .wagce-section.whyagcx_userstay {
    padding: 30px 0 70px;
  }

  .wagce-section h2 {
    font-size: 32px;
  }

  .agcxstay_card h3 {
    font-size: 20px;
  }

  section.wagce-section.wagce-section--soft {
    padding: 50px 0px;
  }

  .agcx_why_services {
    gap: 32px;
  }

  section.wagce-section.the_experience_section {
    padding: 50px 0px;
  }

  .number_term {
    font-size: 24px;
  }

  .term_usages_card h3 {
    font-size: 20px;
  }

  .term_usages_card p {
    font-size: 12px;
  }

  .cnttermswhy {
    min-height: 150px;
    padding: 20px 20px 0px;
  }

  .the_experience_section .wagce-section__head {
    margin: 0 auto 15px;
  }

  .wagce-cta {
    padding: 32px;
  }

  .wagce-cta::before {
    width: 280px;
    right: 60px;
  }

  .wagce-section h2 {
    font-size: 28px;
  }

  .wagce-cta__actions {
    max-width: 350px;
  }


  .wagce-cta {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 767px) {

  .wagce-page {
    padding-bottom: 40px;
  }


  body.light_theme .wagce-stats-box {
    margin-top: 10px;
  }

  .feature_cta.d-flex {
    margin-top: 20px;
  }

  .wagce-section.whyagcx_userstay {
    min-height: auto !important;
    padding: 35px 0 !important;
  }

  .whyagcx_userstay_wrapper {
    position: relative !important;
    height: auto !important;
    top: auto !important;
    transform: none !important;
  }

  .why_agcx_user {
    max-width: 100%;
    height: auto !important;
    margin-top: 24px !important;
    gap: 20px !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .agcxstay_card {
    max-width: 100%;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    opacity: 1 !important;
    min-height: auto !important;
    box-shadow: none !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
  }

  .wagce-hero__layout {
    flex-direction: column;
    text-align: center;
    gap: 24px;
  }

  .wagce-hero {
    padding: 32px 0px;
  }

  .wagce-hero h1 br {
    display: none;
  }

  .wagce-actions,
  .wagce-cta__actions {
    justify-content: center;
  }

  .whyagcx_hero_vector {
    width: 290px;
  }

  .wagce-section h2 {
    font-size: 24px;
  }

  .wagce-hero h1 {
    font-size: 26px;
  }

  .wagce-stat-card__content strong {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .wagce-stat-card__content span {
    font-size: 13px;
  }

  .wagce-section p.sub {
    max-width: 100% !important;
    font-size: 14px;
  }

  section.wagce-section.wagce-section--soft {
    padding: 30px 0px;
    /* text-align: center; */
  }

  .agcx_why_services .wagce-section__head.wagce-section__head--left {
    text-align: center;
    max-width: 100%;
  }

  .features_cnta {
    text-align: left;
  }

  section.wagce-section.the_experience_section {
    padding: 30px 0px;
  }

  .wagce-journey {
    grid-template-columns: 1fr;
  }

  .term_usages_card {
    width: 300px;
    margin: 0 auto;
  }

  .cnttermswhy {
    min-height: 260px;
  }

  .term_usages_card.terms_onebl .number_term {
    bottom: 30px;
  }

  .wagce-cta .wagce-btn {
    min-width: 129px;
    padding: 7px 12px;
    font-size: 13px;
    margin-right: 10px;
    margin-top: 5px;
  }

  .wagce-cta {
    padding: 24px;
  }

  .wagce-cta__actions {
    max-width: 310px;
  }

  .wagce-section .wagce-cta h2 {
    font-size: 22px;
    margin-bottom: 10px;
  }

  .agcx_why_services {
    flex-direction: column;
    gap: 24px;
  }

  .wagce-section--soft {
    padding: 26px 0;
  }
}

@media (max-width: 580px) {



  .wagce-hero {
    padding: 36px 0 30px;
  }

  .wagce-stats-row--top {
    grid-template-columns: repeat(1, 1fr);
  }


  .wagce-stats-row--bottom {
    flex-direction: column;
  }

  .wagce-stats-box {
    padding: 24px;
    gap: 22px;
    margin-bottom: 10px;
  }

  .agcxstay_card {
    max-width: 100%;
    padding: 24px;
    min-height: 100%;
    transform: rotate(0deg);
  }

  .agcxstay_card.cardtwoeffect {
    transform: rotate(0deg);
  }

  .why_agcx_user {
    gap: 24px;
    margin-top: 30px;
  }

  .agcxstay_card h3 {
    font-size: 17px;
  }

  .wagce-section.whyagcx_userstay {
    padding: 30px 0 30px;
    min-height: 100%;
  }

  .wagce-section h2 {
    font-size: 22px;
  }

  .wagce-section.wagce-section--soft .agcx_why_services h2 {
    margin: 12px 0px;
  }

  .agcx_why_services .wagce-section__head p {
    font-size: 15px;
  }

  .feature_cta.d-flex h4 {
    font-size: 18px;
  }

  .wagce-hero h1 {
    font-size: 24px;
    letter-spacing: -1px;
    margin-bottom: 10px;
  }

  .wagce-card {
    border-radius: 18px;
    padding: 22px;
  }

  .wagce-cta {
    padding: 22px 0px 0px 0px;
  }

  .wagce-section.the_experience_section p.subtext {
    padding-top: 0px;
    font-size: 14px;
    margin-bottom: 0px;
  }

  .wagce-journey {
    padding-top: 12px;
  }

  .wagce-btn {
    width: 100%;
  }

  .wagce-cta__actions {
    position: relative;
  }

  .cta_cntlft {
    max-width: 100%;
    text-align: center;
    padding: 0px 24px;
  }

  .wagce-cta::before {
    right: 0px;
    height: 30%;
    top: inherit;
    bottom: 0px;
  }


}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/FooterPages/why-agce.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;;AAGA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yDAAqE;EACrE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,yDAA2E;AAC7E;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kLAAkL;EAClL,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;;;;EAIE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;GAKG;;AAEH;;EAEE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,wEAAwE;AAC1E;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;;;GAKG;;AAEH;;;;GAIG;AACH;;;;;;;;;;KAUK;;AAEL;EACE,UAAU;EACV,yDAAgE;EAChE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,yDAAiE;EACjE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,yDAAuE;AACzE;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4DAA4D;AAC9D;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,0CAA0C;AAC5C;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;GAMG;;AAEH;;;;;GAKG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;;;GAcG;;AAEH;;;;;;;;;;;GAWG;;AAEH;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iCAAiC;EACjC,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;;AAGA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;;EAIA;IACE,cAAc;EAChB;;AAEF;;;AAGA;;;EAGE;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;;;EAGE;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;;EAGA;IACE,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;;EAEE;IACE,oBAAoB;EACtB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;IACpB,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;IACrB,0BAA0B;IAC1B,qBAAqB;IACrB,2BAA2B;IAC3B,2BAA2B;IAC3B,sDAAsD;EACxD;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;;EAIE;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;EACvC;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;;AAGF","sourcesContent":[".wagce-page {\n  background: #171A20;\n  color: #f5f5f5;\n  min-height: 100vh;\n  padding-bottom: 80px;\n}\n\n\nbody.light_theme .wagce-page {\n  background: #fff;\n  color: #161616;\n}\n\n.wagce-hero {\n  padding: 84px 0 48px;\n  background-image: url(\"../../../../public/images/whyagcx_herobg.jpg\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  min-height: 900px;\n  display: flex;\n  align-items: center;\n}\n\n\nbody.light_theme .wagce-hero {\n  background-image: url(\"../../../../public/images/whyagcx_herobg_light.jpg\");\n}\n\n.wagce-hero__inner {\n  max-width: 740px;\n}\n\n.whyagcx_hero_vector {\n  width: 670px;\n  max-width: 100%;\n  opacity: 0.80;\n}\n\n.wagce-hero__layout {\n  display: flex;\n  gap: 32px;\n  align-items: center;\n}\n\n.wagce-hero span.wagce-eyebrow {\n  font-size: 14px;\n  text-transform: uppercase;\n  border: 1px solid rgb(209 170 103 / 30%);\n  color: #D1AA67;\n  border-radius: 50px;\n  padding: 8px 15px;\n  font-weight: 500;\n  margin-bottom: 32px;\n  display: inline-block;\n  letter-spacing: 0.70px;\n}\n\n.wagce-stats-box {\n  background: linear-gradient(#1a1d24, #1a1d24) padding-box, linear-gradient(179deg, rgba(209, 170, 103, 0.65) 0%, rgb(209 170 103 / 3%) 50%, rgb(255 255 255 / 0%) 100%) border-box;\n  border: 1px solid transparent;\n  border-radius: 24px;\n  padding: 44px 48px;\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n  margin-top: 0px;\n  margin-bottom: 24px;\n}\n\nbody.light_theme .wagce-stats-box {\n  background: #e3e2e2;\n  margin-top: 60px;\n  border: 1px solid transparent;\n}\n\n.wagce-stats-row {\n  display: flex;\n  align-items: center;\n}\n\n.wagce-stats-row--top {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n}\n\n.wagce-stats-row--bottom {\n  display: flex;\n  justify-content: center;\n  gap: 64px;\n}\n\n.wagce-stat-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.wagce-stat-card__icon {\n  width: 68px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wagce-stat-card__icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.wagce-stat-card__content {\n  display: flex;\n  flex-direction: column;\n}\n\n.wagce-stat-card__content strong {\n  display: block;\n  font-size: 26px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.2;\n  margin-bottom: 4px;\n}\n\nbody.light_theme .wagce-stat-card__content strong {\n  color: #161616;\n}\n\nbody.light_theme .wagce-stat-card__content span {\n  color: #535353;\n}\n\n.wagce-stat-card__content span {\n  color: #9CA3AF;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.35;\n  max-width: 260px;\n}\n\n/* body.light_theme .wagce-stat-card__content span {\n  color: rgba(22, 22, 22, 0.72);\n} */\n\n/* .wagce-eyebrow {\n  display: inline-block;\n  margin-bottom: 32px;\n  padding: 7px 16px;\n  border: 1px solid rgb(209 170 103 / 20%);\n  border-radius: 999px;\n  background: none;\n  color: #D1AA67;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.70px;\n  text-transform: uppercase;\n} */\n\n.wagce-hero h1,\n.wagce-section h2,\n.wagce-card h3,\n.wagce-cta h2 {\n  color: inherit;\n}\n\n.wagce-hero h1 {\n  font-size: 72px;\n  line-height: 1.14;\n  margin-bottom: 18px;\n  letter-spacing: -1.70px;\n  font-weight: 700;\n}\n\n.wagce-hero h1 span {\n  color: #D1AA67;\n}\n\n.wagce-hero p,\n.wagce-section__head p,\n.wagce-card p,\n.wagce-cta p {\n  color: #9CA3AF;\n}\n\nbody.light_theme .wagce-hero p,\nbody.light_theme .wagce-section__head p,\nbody.light_theme .wagce-card p,\nbody.light_theme .wagce-cta p {\n  color: #454545;\n}\n\n.wagce-hero p {\n  width: 86%;\n  font-weight: 300;\n  font-size: 20px;\n  line-height: 170%;\n}\n\n.wagce-section.whyagcx_userstay h2 {\n  font-weight: 600;\n  background: linear-gradient(270deg, #D1AA67, #fff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n}\n\nbody.light_theme .wagce-section.whyagcx_userstay h2 {\n  background: linear-gradient(270deg, #df872c, #373636);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n}\n\n/* body.light_theme .wagce-hero p,\nbody.light_theme .wagce-section__head p,\nbody.light_theme .wagce-card p,\nbody.light_theme .wagce-cta p {\n  color: rgba(22, 22, 22, 0.72);\n} */\n\n.wagce-actions,\n.wagce-cta__actions {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-top: 32px;\n}\n\n.wagce-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgb(255 255 255 / 12%);\n  min-width: 198px;\n  background: rgb(54 53 53 / 85%);\n  padding: 15px 24px;\n  color: #E5E7EB;\n  align-items: center;\n  gap: 7px;\n  font-size: 18px;\n  border-radius: 999px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: transform 0.2s ease, opacity 0.2s ease, background 0.2s ease;\n}\n\n.wagce-btn:hover {\n  transform: translateY(-1px);\n  opacity: 0.96;\n  color: #fff;\n}\n\n.wagce-btn--primary {\n  background: #D1AA67;\n  color: #fff;\n  border-color: #D1AA67;\n}\n\n/* \n.wagce-btn--secondary {\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: #fff;\n  background: transparent;\n} */\n\n/* .wagce-btn--ghost {\n  border: 1px solid rgba(209, 170, 103, 0.32);\n  color: #d1aa67;\n  background: rgba(209, 170, 103, 0.08);\n} */\n/* \n  body.light_theme .wagce-btn--secondary {\n    border-color: rgba(17, 17, 17, 0.14);\n    color: #161616;\n  }\n\n  body.light_theme .wagce-btn--ghost {\n    border-color: rgba(209, 170, 103, 0.28);\n    color: #9d793d;\n    background: rgba(209, 170, 103, 0.12);\n  } */\n\n.wagce-section.whyagcx_userstay {\n  padding: 0;\n  background-image: url(\"../../../../public/images/whyuserbg.jpg\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  min-height: 2500px;\n  position: relative;\n}\n\nbody.light_theme .wagce-section.whyagcx_userstay {\n  background-color: #fff;\n  background-image: none;\n}\n\n.whyagcx_userstay_wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.wagce-section.whyagcx_userstay.state-pinned .whyagcx_userstay_wrapper {\n  position: fixed;\n  top: 0px;\n  left: 0;\n  z-index: 99;\n}\n\n.wagce-section.whyagcx_userstay.state-after .whyagcx_userstay_wrapper {\n  position: absolute;\n  top: auto;\n  bottom: 0;\n}\n\nsection.wagce-section.wagce-section--soft {\n  padding: 100px 0 90px;\n  background-image: url(\"../../../../public/images/whyagcx_bg.jpg\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n\nbody.light_theme section.wagce-section.wagce-section--soft {\n  background-image: url(\"../../../../public/images/whyagcx_bg_light.jpg\");\n}\n\nspan.wagce-eyebrow {\n  font-size: 20px;\n  color: #D1AA67;\n  font-weight: 500;\n  letter-spacing: 1.9px;\n}\n\n.agcx_why_services {\n  width: 100%;\n  display: flex;\n  gap: 72px;\n  align-items: center;\n}\n\n.agcx_why_services .wagce-section__head.wagce-section__head--left {\n  max-width: 580px;\n}\n\n.wagce-section.wagce-section--soft h2 span {\n  color: #D1AA67;\n}\n\n.wagce-section.wagce-section--soft .agcx_why_services h2 {\n  margin: 24px 0px;\n}\n\n.agcx_why_services .wagce-section h2 {\n  max-width: 90%;\n  margin: 18px 0px;\n  font-weight: 500;\n}\n\n.agcx_why_services .wagce-section__head p {\n  font-size: 24px;\n  font-weight: 300;\n  line-height: 160%;\n}\n\nsection.wagce-section.the_experience_section {\n  padding: 120px 0px;\n}\n\n.the_experience_section .wagce-eyebrow {\n  letter-spacing: 3px;\n  font-size: 13px;\n  padding-bottom: 13px;\n  display: block;\n}\n\n.wagce-section.the_experience_section h2 span {\n  color: #D1AA67;\n}\n\n.wagce-section.the_experience_section p.subtext {\n  padding-top: 8px;\n  font-size: 16px;\n}\n\nimg.roatateright {\n  transform: rotate(180deg);\n}\n\n.the_experience_section .wagce-section__head {\n  max-width: 840px;\n  margin: 0 auto 36px;\n}\n\n.feature_cta.d-flex {\n  width: 100%;\n  background: rgb(255 255 255 / 5%);\n  border: 1px solid rgb(209 170 103 / 25%);\n  border-radius: 22px;\n  position: relative;\n  gap: 24px;\n  padding: 36px;\n  margin-top: 32px;\n  backdrop-filter: blur(2px);\n}\n\nbody.light_theme .feature_cta.d-flex {\n  background: rgb(255 255 255 / 30%);\n}\n\n.feature_cta.d-flex h4 {\n  font-weight: 700;\n  font-size: 24px;\n  color: #D1AA67;\n}\n\n.feature_cta.d-flex::before {\n  width: 120px;\n  height: 120px;\n  background: rgb(209 170 103 / 30%);\n  content: \"\";\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  filter: blur(30px);\n}\n\n.agcx_why_services .wagce-section__head .feature_cta p {\n  font-size: 19px;\n  font-weight: 400;\n}\n\n.wagce-section__head {\n  max-width: 100%;\n  margin: 0 auto 28px;\n  text-align: center;\n}\n\n.wagce-section__head--left {\n  margin: 0;\n  text-align: left;\n}\n\n.wagce-section h2 {\n  font-size: 54px;\n  margin-bottom: 14px;\n  font-weight: 600;\n}\n\n\n.wagce-section p.sub {\n  max-width: 754px;\n  font-size: 22px;\n  line-height: 140%;\n  font-weight: 300;\n  color: #9EA6B6;\n  margin: 24px auto;\n}\n\nbody.light_theme .wagce-section p.sub {\n  color: #1e1e1e;\n}\n\n\n.agcxstay_card.cardtwoeffect {\n  transform: rotate(-15deg);\n}\n\n.why_agcx_user {\n  max-width: 400px;\n  width: 100%;\n  position: relative;\n  margin: 112px auto 0;\n  height: 400px;\n}\n\n.agcxstay_card {\n  max-width: 396px;\n  width: 100%;\n  background-color: #202329;\n  border: 1px solid rgb(255 255 255 / 8%);\n  border-radius: 30px;\n  padding: 24px;\n  box-shadow: 0px 16px 36px rgba(0, 0, 0, 0.5);\n  min-height: 354px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  backdrop-filter: blur(10px);\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: transform 0.15s ease-out, opacity 0.15s ease-out;\n}\n\nbody.light_theme .agcxstay_card {\n  background-color: rgb(223 223 223 / 60%);\n  border: 1px solid rgb(255 255 255 / 8%);\n  box-shadow: 0px 16px 36px rgb(0 0 0 / 20%);\n}\n\n\n.whyagcx_stay_vector {\n  max-width: 60px;\n}\n\n.stay_effect {\n  background: rgb(255 255 255 / 5%);\n  font-size: 12px;\n  padding: 10px 20px;\n  display: inline-block;\n  border-radius: 50px;\n  box-shadow: inset 2px 4px 16px rgb(248 248 248 / 6%);\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n.agcxstay_card h3 {\n  font-size: 24px;\n}\n\n.agcxstay_card p {\n  font-size: 12px;\n  color: #a7a7a7;\n}\n\nbody.light_theme .agcxstay_card p {\n  color: #272626;\n}\n\n/* .wagce-card,\n.wagce-list-card,\n.wagce-cta {\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 24px;\n} */\n\n/* body.light_theme .wagce-card,\nbody.light_theme .wagce-list-card,\nbody.light_theme .wagce-cta {\n  border-color: rgba(17, 17, 17, 0.08);\n  background: #fff;\n} */\n\n.wagce-card {\n  padding: 28px;\n}\n\n.wagce-card h3 {\n  font-size: 1.2rem;\n  margin-bottom: 12px;\n  font-weight: 700;\n}\n\n/* .wagce-list-card {\n  padding: 26px;\n} */\n\n/* .wagce-list-item {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  padding: 14px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .wagce-list-item {\n  border-bottom-color: rgba(17, 17, 17, 0.08);\n}\n\n.wagce-list-item:last-child {\n  border-bottom: none;\n} */\n\n/* .wagce-list-item__icon {\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(209, 170, 103, 0.15);\n  color: #d1aa67;\n  font-weight: 700;\n} */\n\n.wagce-cta {\n  padding: 54px;\n  min-height: 420px;\n  border-radius: 24px;\n  margin-top: 32px;\n  overflow: hidden;\n  display: flex;\n  border: 1px solid rgb(255 255 255 / 10%);\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  background: rgb(255 255 255 / 5%);\n  box-shadow: inset 0 0px 15px rgba(0, 0, 0, 0.25);\n  position: relative;\n}\n\n.wagce-cta::before {\n  width: 350px;\n  height: 100%;\n  background: rgb(209 170 103 / 25%);\n  content: \"\";\n  position: absolute;\n  right: 190px;\n  top: 0px;\n  filter: blur(100px);\n}\n\n.wagce-cta h2 {\n  margin-bottom: 20px;\n  font-weight: 600;\n  line-height: 1.1;\n  font-size: 48px;\n  letter-spacing: -1.2px;\n}\n\n.wagce-cta .wagce-btn {\n  min-width: 165px;\n  padding: 11px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  margin-right: 15px;\n  margin-top: 15px;\n}\n\n.wagce-cta .wagce-btn:hover {\n  color: #fff;\n}\n\n.cta_cntlft {\n  max-width: 725px;\n}\n\n.wagce-cta h2 span {\n  color: #D1AA67;\n}\n\n.wagce-cta p {\n  font-size: 14px;\n  font-weight: 300;\n}\n\n.wagce-cta__actions {\n  max-width: 550px;\n  position: absolute;\n  right: 0px;\n  bottom: 0px;\n}\n\n.wagce-journey {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 42px;\n  padding-top: 26px;\n}\n\n.wagce-journey-card {\n  padding: 28px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.term_usages_card {\n  width: 100%;\n  position: relative;\n  height: 100%;\n}\n\n.termcard_img {\n  position: absolute;\n}\n\nbody.light_theme .termcard_img {\n  opacity: 0.3;\n}\n\n.cnttermswhy {\n  padding: 42px 42px 0px;\n  /* color: #fff; */\n  position: relative;\n  min-height: 270px;\n}\n\n.term_usages_card h3 {\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.term_usages_card h3 span {\n  color: #D1AA67;\n  display: block;\n}\n\n.term_usages_card p {\n  font-size: 18px;\n  color: rgb(255 255 255 / 60%);\n}\n\nbody.light_theme .term_usages_card p {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.number_term {\n  font-size: 52px;\n  font-weight: 600;\n  color: #D1AA67;\n}\n\n.term_usages_card.terms_onebl .number_term {\n  position: absolute;\n  bottom: -90px;\n}\n\n\nbody.light_theme .wagce-journey-card {\n  border-color: rgba(17, 17, 17, 0.08);\n  background: #fff;\n}\n\n.wagce-journey-card__step {\n  display: inline-flex;\n  min-width: 48px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  border-radius: 999px;\n  margin-bottom: 16px;\n  background: rgba(209, 170, 103, 0.14);\n  color: #d1aa67;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n}\n\n.wagce-journey-card h3 {\n  margin-bottom: 12px;\n  font-size: 1.2rem;\n}\n\n.wagce-journey-card p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.76);\n}\n\nbody.light_theme .wagce-journey-card p {\n  color: rgba(22, 22, 22, 0.72);\n}\n\n@media (max-width:1500px) {\n\n\n  .term_usages_card h3 {\n    font-size: 36px;\n  }\n\n  .term_usages_card p {\n    font-size: 15px;\n  }\n\n  .cnttermswhy {\n    padding: 32px 32px 0px;\n    min-height: 230px;\n  }\n\n  .wagce-hero h1 {\n    font-size: 60px;\n  }\n\n}\n\n\n@media (max-width:1367px) {\n\n  .cnttermswhy {\n    min-height: 200px;\n  }\n\n  .wagce-hero h1 {\n    font-size: 52px;\n  }\n\n  .wagce-section h2 {\n    font-size: 48px;\n  }\n\n  .term_usages_card h3 {\n    font-size: 32px;\n  }\n\n  .term_usages_card p {\n    font-size: 14px;\n  }\n\n  .number_term {\n    font-size: 40px;\n  }\n\n\n\n  .cta_cntlft {\n    max-width: 50%;\n  }\n\n}\n\n\n@media (max-width: 1200px) {\n\n\n  .wagce-hero {\n    padding: 84px 0 48px;\n    min-height: 100%;\n  }\n\n  .wagce-page .container {\n    max-width: 95%;\n  }\n\n  .wagce-hero p {\n    width: 100%;\n    font-size: 16px;\n  }\n\n  .wagce-stat-card__content strong {\n    font-size: 20px;\n  }\n\n  .wagce-stat-card__content span {\n    font-size: 14px;\n  }\n\n  .wagce-stats-box {\n    padding: 36px;\n  }\n\n  .wagce-section h2 {\n    font-size: 38px;\n  }\n\n  .wagce-section p.sub {\n    max-width: 90% !important;\n    font-size: 16px;\n  }\n\n  .agcx_why_services .wagce-section__head p {\n    font-size: 16px;\n  }\n\n  span.wagce-eyebrow {\n    font-size: 15px;\n  }\n\n  .feature_cta.d-flex {\n    gap: 18px;\n    padding: 24px;\n  }\n\n  .agcx_why_services .wagce-section__head .feature_cta p {\n    font-size: 15px;\n  }\n\n  .feature_cta.d-flex h4 {\n    font-size: 20px;\n  }\n\n  .term_usages_card h3 {\n    font-size: 24px;\n  }\n\n  .number_term {\n    font-size: 32px;\n  }\n\n  .wagce-hero h1 {\n    font-size: 42px;\n  }\n\n  .wagce-btn {\n    font-size: 13px;\n    min-width: 150px;\n    padding: 10px 22px;\n  }\n\n  .term_usages_card.terms_onebl .number_term {\n    bottom: -40px;\n  }\n\n  .cnttermswhy {\n    min-height: 190px;\n    padding: 24px 24px 0px;\n  }\n\n  .wagce-journey {\n    gap: 24px;\n  }\n\n  .wagce-cta__actions {\n    max-width: 430px;\n  }\n\n}\n\n@media (max-width: 991px) {\n\n\n  .wagce-hero h1 {\n    font-size: 32px;\n  }\n\n  .wagce-hero {\n    padding: 48px 0 48px;\n  }\n\n  .wagce-page .container {\n    max-width: 100%;\n  }\n\n  .wagce-hero p {\n    margin-bottom: 0px;\n    font-size: 15px;\n  }\n\n  .wagce-actions,\n  .wagce-cta__actions {\n    gap: 8px;\n    margin-top: 22px;\n  }\n\n  .wagce-hero span.wagce-eyebrow {\n    font-size: 12px;\n    padding: 6px 12px;\n    margin-bottom: 18px;\n  }\n\n\n  .wagce-stats-box {\n    padding: 32px 24px;\n    gap: 28px;\n    margin-top: 0;\n  }\n\n  .wagce-stats-row--top,\n  .wagce-stats-row--bottom {\n    gap: 18px;\n  }\n\n  .wagce-stat-card__icon {\n    width: 48px;\n  }\n\n  .wagce-stat-card__content strong {\n    font-size: 18px;\n  }\n\n  .wagce-section.whyagcx_userstay {\n    padding: 30px 0 70px;\n  }\n\n  .wagce-section h2 {\n    font-size: 32px;\n  }\n\n  .agcxstay_card h3 {\n    font-size: 20px;\n  }\n\n  section.wagce-section.wagce-section--soft {\n    padding: 50px 0px;\n  }\n\n  .agcx_why_services {\n    gap: 32px;\n  }\n\n  section.wagce-section.the_experience_section {\n    padding: 50px 0px;\n  }\n\n  .number_term {\n    font-size: 24px;\n  }\n\n  .term_usages_card h3 {\n    font-size: 20px;\n  }\n\n  .term_usages_card p {\n    font-size: 12px;\n  }\n\n  .cnttermswhy {\n    min-height: 150px;\n    padding: 20px 20px 0px;\n  }\n\n  .the_experience_section .wagce-section__head {\n    margin: 0 auto 15px;\n  }\n\n  .wagce-cta {\n    padding: 32px;\n  }\n\n  .wagce-cta::before {\n    width: 280px;\n    right: 60px;\n  }\n\n  .wagce-section h2 {\n    font-size: 28px;\n  }\n\n  .wagce-cta__actions {\n    max-width: 350px;\n  }\n\n\n  .wagce-cta {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 767px) {\n\n  .wagce-page {\n    padding-bottom: 40px;\n  }\n\n\n  body.light_theme .wagce-stats-box {\n    margin-top: 10px;\n  }\n\n  .feature_cta.d-flex {\n    margin-top: 20px;\n  }\n\n  .wagce-section.whyagcx_userstay {\n    min-height: auto !important;\n    padding: 35px 0 !important;\n  }\n\n  .whyagcx_userstay_wrapper {\n    position: relative !important;\n    height: auto !important;\n    top: auto !important;\n    transform: none !important;\n  }\n\n  .why_agcx_user {\n    max-width: 100%;\n    height: auto !important;\n    margin-top: 24px !important;\n    gap: 20px !important;\n    display: flex !important;\n    flex-direction: column !important;\n  }\n\n  .agcxstay_card {\n    max-width: 100%;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    opacity: 1 !important;\n    min-height: auto !important;\n    box-shadow: none !important;\n    border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  }\n\n  .wagce-hero__layout {\n    flex-direction: column;\n    text-align: center;\n    gap: 24px;\n  }\n\n  .wagce-hero {\n    padding: 32px 0px;\n  }\n\n  .wagce-hero h1 br {\n    display: none;\n  }\n\n  .wagce-actions,\n  .wagce-cta__actions {\n    justify-content: center;\n  }\n\n  .whyagcx_hero_vector {\n    width: 290px;\n  }\n\n  .wagce-section h2 {\n    font-size: 24px;\n  }\n\n  .wagce-hero h1 {\n    font-size: 26px;\n  }\n\n  .wagce-stat-card__content strong {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .wagce-stat-card__content span {\n    font-size: 13px;\n  }\n\n  .wagce-section p.sub {\n    max-width: 100% !important;\n    font-size: 14px;\n  }\n\n  section.wagce-section.wagce-section--soft {\n    padding: 30px 0px;\n    /* text-align: center; */\n  }\n\n  .agcx_why_services .wagce-section__head.wagce-section__head--left {\n    text-align: center;\n    max-width: 100%;\n  }\n\n  .features_cnta {\n    text-align: left;\n  }\n\n  section.wagce-section.the_experience_section {\n    padding: 30px 0px;\n  }\n\n  .wagce-journey {\n    grid-template-columns: 1fr;\n  }\n\n  .term_usages_card {\n    width: 300px;\n    margin: 0 auto;\n  }\n\n  .cnttermswhy {\n    min-height: 260px;\n  }\n\n  .term_usages_card.terms_onebl .number_term {\n    bottom: 30px;\n  }\n\n  .wagce-cta .wagce-btn {\n    min-width: 129px;\n    padding: 7px 12px;\n    font-size: 13px;\n    margin-right: 10px;\n    margin-top: 5px;\n  }\n\n  .wagce-cta {\n    padding: 24px;\n  }\n\n  .wagce-cta__actions {\n    max-width: 310px;\n  }\n\n  .wagce-section .wagce-cta h2 {\n    font-size: 22px;\n    margin-bottom: 10px;\n  }\n\n  .agcx_why_services {\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  .wagce-section--soft {\n    padding: 26px 0;\n  }\n}\n\n@media (max-width: 580px) {\n\n\n\n  .wagce-hero {\n    padding: 36px 0 30px;\n  }\n\n  .wagce-stats-row--top {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n\n  .wagce-stats-row--bottom {\n    flex-direction: column;\n  }\n\n  .wagce-stats-box {\n    padding: 24px;\n    gap: 22px;\n    margin-bottom: 10px;\n  }\n\n  .agcxstay_card {\n    max-width: 100%;\n    padding: 24px;\n    min-height: 100%;\n    transform: rotate(0deg);\n  }\n\n  .agcxstay_card.cardtwoeffect {\n    transform: rotate(0deg);\n  }\n\n  .why_agcx_user {\n    gap: 24px;\n    margin-top: 30px;\n  }\n\n  .agcxstay_card h3 {\n    font-size: 17px;\n  }\n\n  .wagce-section.whyagcx_userstay {\n    padding: 30px 0 30px;\n    min-height: 100%;\n  }\n\n  .wagce-section h2 {\n    font-size: 22px;\n  }\n\n  .wagce-section.wagce-section--soft .agcx_why_services h2 {\n    margin: 12px 0px;\n  }\n\n  .agcx_why_services .wagce-section__head p {\n    font-size: 15px;\n  }\n\n  .feature_cta.d-flex h4 {\n    font-size: 18px;\n  }\n\n  .wagce-hero h1 {\n    font-size: 24px;\n    letter-spacing: -1px;\n    margin-bottom: 10px;\n  }\n\n  .wagce-card {\n    border-radius: 18px;\n    padding: 22px;\n  }\n\n  .wagce-cta {\n    padding: 22px 0px 0px 0px;\n  }\n\n  .wagce-section.the_experience_section p.subtext {\n    padding-top: 0px;\n    font-size: 14px;\n    margin-bottom: 0px;\n  }\n\n  .wagce-journey {\n    padding-top: 12px;\n  }\n\n  .wagce-btn {\n    width: 100%;\n  }\n\n  .wagce-cta__actions {\n    position: relative;\n  }\n\n  .cta_cntlft {\n    max-width: 100%;\n    text-align: center;\n    padding: 0px 24px;\n  }\n\n  .wagce-cta::before {\n    right: 0px;\n    height: 30%;\n    top: inherit;\n    bottom: 0px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
